/* ============= WR Variant Selectors JS =============
   Add tiny behavior/states on top of Xtra’s radios so
   we can style parents on selection + mirror the current
   selection in headings if desired.
   ================================================== */

(function () {
  function enhanceGroup(fieldset) {
    if (!fieldset) return;
    const group = fieldset.querySelectorAll('ul.check input[type="radio"]');
    if (!group.length) return;

    // Add an is-selected class to the <li> for easier styling
    group.forEach((input) => {
      const li = input.closest('li');
      const setState = () => {
        // clear siblings
        fieldset.querySelectorAll('ul.check li.is-selected').forEach((el) => {
          el.classList.remove('is-selected');
        });
        if (input.checked && li) li.classList.add('is-selected');

        // Optional: write current value beside the heading text (like “POSTER COLOR: Tasty Blue”)
        const labelEl = fieldset.querySelector('label.no-js-hidden, label[for^="option-"]');
        const selectedLabel = input.nextElementSibling;
        const textSpan = selectedLabel ? selectedLabel.querySelector('span') : null;
        const valueText = textSpan ? textSpan.textContent.trim() : (selectedLabel ? selectedLabel.getAttribute('title') || '' : '');
        if (labelEl) {
          let badge = labelEl.querySelector('.wr-current');
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'wr-current';
            badge.style.marginLeft = '8px';
            badge.style.fontWeight = '600';
            labelEl.appendChild(badge);
          }
          if (valueText) badge.textContent = valueText;
        }
      };

      input.addEventListener('change', setState);
      if (input.checked) setState();
    });
  }

  function boot() {
    document.querySelectorAll('fieldset.wr-variant').forEach(enhanceGroup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // If the theme swaps variants via Ajax and re-renders blocks,
  // listen for a simple custom event to re-bind (optional).
  document.addEventListener('wr:refresh-variants', boot);
})();
